import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	color: ${palette('white')};
	text-align: center;
	margin: 0 auto;
	max-width: 460px;
`;

export const Icons = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 16px;
`;

export const Icon = styled.svg`
	height: 36px;
	margin: 12px;
	width: 36px;

	& path {
		fill: ${palette('white')};
	}
`;

export const Description = styled(Text).attrs({
	el: 'h2',
	styleAs: 'h5',
})`
	font-weight: 400;
	margin-top: 0;
	margin-bottom: 24px;
`;
